import { LIST_WIDTH, ARCHIVED_COLUMN } from 'utils/constants/listview';

export const columns = [
  ARCHIVED_COLUMN,
  {
    headerName: 'Category',
    field: 'category',
    cellRenderer: 'activityComponent',
    cellRendererParams: {
      displayType: 'icon',
    },
    width: LIST_WIDTH.HUMAN_READABLE_ID,
  },
  {
    headerName: 'Type Name',
    field: 'name',
    width: LIST_WIDTH.HUMAN_READABLE_ID,
  },
  // {
  //   headerName: 'Qualification Required',
  //   field: 'qualificationRequired',
  //   width: LIST_WIDTH.HUMAN_READABLE_ID,
  // },
];
